<template>
  <div class="passcode-overlay">
    <div class="passcode-container">
      <h2>Enter Passcode</h2>
      <input
        type="password"
        v-model="passcode"
        maxlength="6"
        placeholder="******"
        @input="checkPasscode"
      >
      <p v-if="error" class="error-message">{{ error }}</p>
      <div v-if="showStayLoggedIn" class="stay-logged-in">
        <p>Stay logged in?</p>
        <div class="button-group">
          <button @click="handleStayLoggedIn(true)">Yes</button>
          <button @click="handleStayLoggedIn(false)">No</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

const PASSCODE = "353369";

export default {
  name: 'PasscodeOverlay',
  emits: ['passcode-verified', 'stay-logged-in'],
  setup(props, { emit }) {
    const passcode = ref('');
    const error = ref('');
    const showStayLoggedIn = ref(false);

    const checkPasscode = () => {
      if (passcode.value.length === 6) {
        if (passcode.value === PASSCODE) {
          showStayLoggedIn.value = true;
        } else {
          error.value = "Incorrect passcode. Please try again.";
          passcode.value = '';
        }
      }
    };

    const handleStayLoggedIn = (stay) => {
      emit('stay-logged-in', stay);
      emit('passcode-verified');
    };

    return {
      passcode,
      error,
      showStayLoggedIn,
      checkPasscode,
      handleStayLoggedIn,
    };
  },
};
</script>

<style scoped>
.passcode-overlay {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  justify-content: center;
  align-items: center;
}

.passcode-container {
  background-color: #1e1e1e;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}

.passcode-container h2 {
  color: #ffffff;
  margin-bottom: 20px;
}

input {
  width: 200px;
  height: 40px;
  font-size: 24px;
  text-align: center;
  letter-spacing: 10px;
  background-color: #2c2c2c;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  margin-bottom: 10px;
}

.error-message {
  color: #ff0000;
  font-size: 14px;
  margin-top: 10px;
}

.stay-logged-in {
  margin-top: 20px;
}

.stay-logged-in p {
  color: #ffffff;
  margin-bottom: 10px;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.button-group button {
  padding: 5px 15px;
  background-color: #4ecdc4;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.button-group button:hover {
  background-color: #45b7ae;
}
</style>

